// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanScenario.yaml
// Generated: 2026-06-02T14:10:16.213Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanScenario, UpdatePlanScenario, PlanScenario } from '@/types/finance/PlanScenario';

/**
 * PlanScenario Service
 * CRUD operations for PlanScenario via the ABP API.
 */
export const planScenarioService = new EntityService<PlanScenario, CreatePlanScenario, UpdatePlanScenario>(
  '/api/finance/planscenario',
  'PlanScenario',
);
